module.exports = __webpack_public_path__ + "static/media/paint-roller.d4e5e170.svg";